<script setup lang="ts">
type Props = {
  name: 'pig' | 'hand'
}
const props = defineProps<Props>()

const imagesList = {
  background: 'bonus/background.webp',
  foreground: `bonus/${props.name}/foreground.webp`,
  'decor-left': `bonus/${props.name}/decor-left.webp`,
  'decor-right': `bonus/${props.name}/decor-right.webp`,
  'flash-left': `bonus/${props.name}/flash-left.webp`,
  'flash-right': `bonus/${props.name}/flash-right.webp`,
}

const imageAlt = computed(() => `Анимация изображения ${props.name}`)
</script>

<template>
  <div class="bonus-animation">
    <nuxt-img
      v-for="(image, key) in imagesList"
      :key="key"
      class="bonus-animation__image"
      :class="[`bonus-animation__image--${key}`]"
      :src="image"
      :alt="imageAlt"
      width="156"
      height="187"
    />
  </div>
</template>

<style lang="scss" scoped>
.bonus-animation {
  position: relative;
  width: 156px;
  height: 187px;

  &__image {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
}

// TODO: Не понял что за проблема, но с вложенными стилями модификаторы с анимацией не заработали в билде. Локально всё работает
.bonus-animation__image--foreground {
  animation: foreground 5s linear infinite;
}

.bonus-animation__image--decor-left {
  animation: decor 5s linear infinite;
}

.bonus-animation__image--decor-right {
  animation: decor 5s linear infinite 2s;
}

.bonus-animation__image--flash-left {
  animation: flash 4s linear infinite;
}

.bonus-animation__image--flash-right {
  animation: flash 4s linear infinite reverse 1s;
}

@keyframes foreground {
  0%,
  100% {
    transform: translateY(-5px);
  }
  50% {
    transform: translateY(5px);
  }
}

@keyframes decor {
  0%,
  100% {
    transform: translateY(0px) rotate(0);
  }
  50% {
    transform: translateY(-5px) rotate(7deg);
  }
}

@keyframes flash {
  0%,
  100% {
    opacity: 1;
  }
  20%,
  40%,
  60%,
  80% {
    opacity: 0;
  }
}
</style>
